import { BookingTable } from '@services/member/booking/booking.types';

export type BookingAlert = {
    label: string;
    tone: 'error' | 'warning';
};

/**
 * Points d'attention affichés dans la colonne "Suivi" de la liste des réservations.
 *
 * Règle en place : paiement en attente (drapeau calculé côté API, voir
 * Booking::getPaymentInPending). Les autres règles métier se définissent ici,
 * à partir des champs disponibles dans BookingTable.
 */
export const getBookingAlerts = (booking: BookingTable): BookingAlert[] => {
    const alerts: BookingAlert[] = [];

    if (booking.paymentInPending) {
        alerts.push({ label: 'Paiement en attente', tone: 'error' });
    }

    // TODO(Adrien) : règles supplémentaires à valider avec COSEM (voir discussion)

    return alerts;
};
